<div class="jmWidgetPadding" style="overflow:auto; max-height:90vh;">
	<div class="jmPageTitle w-100" display="table-cell" style="margin-bottom: 15px;">
		<div class="w-100 "style="display: table-cell">
			You are now following the <span class="fw-bold">{{objectName}}</span> occupation.
		</div>
		<div style="display: table-cell">
			<span class="jmCloseBtn" role="button" (click)="close($event)"></span>
		</div>
	</div>

	<div class="text-center">
		<div style="margin-bottom: 30px;">
			Do you want to receive notificaions about this occupation?
		</div>
		<div class="row">
			<div class="col-6 text-center">
				<button (click)="toggleStatus(false)" class="btn btn-outline-primary" style="width: 80px;">No</button>
			</div>
			<div class="col-6 text-center">
				<button (click)="toggleStatus(true)" class="btn btn-primary" style="width: 80px;">YES</button>
			</div>
		</div>
	</div>
</div>

